import React, { useState } from 'react';
import { X, Send, CheckCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { toast } from 'sonner';

const DemoModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    phone: '',
    email: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate form submission
    await new Promise((resolve) => setTimeout(resolve, 1500));
    
    setIsSuccess(true);
    toast.success('Demo talebiniz alındı!', {
      description: 'En kısa sürede sizinle iletişime geçeceğiz.',
    });
    
    setTimeout(() => {
      setFormData({ name: '', company: '', phone: '', email: '' });
      setIsSubmitting(false);
      setIsSuccess(false);
      onClose();
    }, 2000);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-gradient-to-br from-[#1F1914] to-[#1A1512] border-[#C9A97B]/20 text-[#F5F0E8] max-w-md">
        {isSuccess ? (
          <div className="py-8 text-center">
            <div className="w-16 h-16 mx-auto rounded-full bg-[#C9A97B]/20 flex items-center justify-center mb-4">
              <CheckCircle className="w-8 h-8 text-[#C9A97B]" />
            </div>
            <h3 className="text-xl font-display font-bold text-[#F5F0E8] mb-2">
              Talebiniz Alındı!
            </h3>
            <p className="text-[#BFB5A5]">
              En kısa sürede sizinle iletişime geçeceğiz.
            </p>
          </div>
        ) : (
          <>
            <DialogHeader>
              <DialogTitle className="text-xl font-display font-bold text-[#F5F0E8]">
                Ücretsiz Demo Talep Et
              </DialogTitle>
              <p className="text-[#7A7067] text-sm mt-1">
                Bilgilerinizi bırakın, uzman ekibimiz sizinle iletişime geçsin.
              </p>
            </DialogHeader>

            <form onSubmit={handleSubmit} className="space-y-4 mt-4">
              <div className="space-y-2">
                <Label htmlFor="modal-name" className="text-[#BFB5A5]">Ad Soyad *</Label>
                <Input
                  id="modal-name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="bg-[#251E18] border-[#C9A97B]/20 text-[#F5F0E8] placeholder:text-[#7A7067] focus:border-[#C9A97B]"
                  placeholder="Adınızı girin"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="modal-company" className="text-[#BFB5A5]">İşletme Adı *</Label>
                <Input
                  id="modal-company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  required
                  className="bg-[#251E18] border-[#C9A97B]/20 text-[#F5F0E8] placeholder:text-[#7A7067] focus:border-[#C9A97B]"
                  placeholder="İşletme adınız"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="modal-phone" className="text-[#BFB5A5]">Telefon *</Label>
                <Input
                  id="modal-phone"
                  name="phone"
                  type="tel"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="bg-[#251E18] border-[#C9A97B]/20 text-[#F5F0E8] placeholder:text-[#7A7067] focus:border-[#C9A97B]"
                  placeholder="0534 662 18 44"
                />
              </div>

              <div className="space-y-2">
                <Label htmlFor="modal-email" className="text-[#BFB5A5]">E-posta</Label>
                <Input
                  id="modal-email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="bg-[#251E18] border-[#C9A97B]/20 text-[#F5F0E8] placeholder:text-[#7A7067] focus:border-[#C9A97B]"
                  placeholder="ornek@email.com"
                />
              </div>

              <Button
                type="submit"
                disabled={isSubmitting}
                className="w-full btn-gold py-4 rounded-xl font-semibold flex items-center justify-center gap-2 mt-6"
              >
                {isSubmitting ? (
                  <>
                    <div className="w-5 h-5 border-2 border-[#1A1512]/30 border-t-[#1A1512] rounded-full animate-spin" />
                    Gönderiliyor...
                  </>
                ) : (
                  <>
                    Demo Talep Et
                    <Send className="w-4 h-4" />
                  </>
                )}
              </Button>

              <p className="text-[#7A7067] text-xs text-center">
                Bilgileriniz gizli tutulacak ve sadece iletişim amacıyla kullanılacaktır.
              </p>
            </form>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default DemoModal;
